import React, { useEffect, useState } from 'react'

import { HAS_WINDOW } from '../../../constants'
import { useStoreContext } from '../../../contexts/StoreContext'
import useWindowDimensions from '../../../hooks/useWindowDimensions'
import { validatePlatform } from '../../../utils/validatePlatform'
import Menu from '../DesktopMenu/DesktopMenu'
import { RegionalizationInfos } from '../Header/components/Regionalization/RegionalizationInfos'
import './common-render.scss'

const CommonDesktopNavigationRender = () => {
  const [topHeigth, setTopHeigth] = useState(0)
  const { notificationsBar } = useStoreContext()
  const [hasNotificationBar, setHasNotificationBar] = useState(false)
  const { isMobile } = useWindowDimensions()

  const notificationBarComponent = validatePlatform({
    isMobile,
    platforms: notificationsBar?.platforms,
  })

  useEffect(() => {
    if (!HAS_WINDOW) {
      return
    }

    const mainHeaderHeight =
      document.getElementById('main-header')?.clientHeight

    if (mainHeaderHeight && topHeigth === 0) {
      setTopHeigth(mainHeaderHeight)
    }

    // Getting the header height when have notification bar

    if (
      notificationBarComponent &&
      notificationsBar &&
      !hasNotificationBar &&
      mainHeaderHeight
    ) {
      setHasNotificationBar(true)
      setTopHeigth(mainHeaderHeight)
    }
  }, [
    !HAS_WINDOW,
    topHeigth,
    hasNotificationBar,
    notificationBarComponent,
    notificationsBar,
  ])

  if (topHeigth <= 0) {
    return null
  }

  return (
    <section
      className="common-desktop-navigation-render"
      id="common-desktop-navigation-render"
      style={{ top: topHeigth }}
    >
      <Menu />
      <RegionalizationInfos />
    </section>
  )
}

export default CommonDesktopNavigationRender
